<div class="agent-container">
    <h3>Realtime Voice Agent</h3>
    <!-- <p *ngIf="transcript"><strong>You said:</strong> {{ transcript }}</p> -->
  
    <button #startBtn (click)="startStreaming()" [disabled]="isRecording">
      Start Talking
    </button>
    <button #stopBtn (click)="stopStreaming()" [disabled]="!isRecording">
      Stop
    </button>
  </div>
  